const TOKEN_PATTERN = /^RCCFD2026(?:-OCT24)?-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function normalizeQrCredential(value = "") {
  let credential = value.trim();
  if (/^https?:\/\//i.test(credential)) {
    try { credential = new URL(credential).searchParams.get("qr") || credential; }
    catch { /* Return the original value so validation can explain the expected format. */ }
  }
  return credential.replace(/^QR#/i, "").trim();
}

export function isFoodDriveQrCredential(value = "") {
  return TOKEN_PATTERN.test(normalizeQrCredential(value));
}
